const isLastCharacter = text => pos => pos === text.length - 1

export default isLastCharacter
